export enum PickingRouteDetailsReviewType {
  AllProductDetails = 1,
  InProgressDetails = 2
}
